import { useNavigate } from "react-router-dom";
import OutlinedButton from "../../../../../components/common/OutlinedButton";
import { IContractDetailsResponseData } from "../../../../../setup/api/services/contract/models";
import { ROUTES } from "../../../../../setup/constants";
import { useTranslation } from "react-i18next";
import PrimaryButton from "../../../../../components/common/PrimaryButton";
import { useCallback, useState } from "react";
import { AuthConfig } from "../../../../../setup/context/config/authConfig";
import { buildContractShareLink } from "../../../../../setup/util/contract";

interface CreatedActionsProps {
  milestone: IContractDetailsResponseData;
}

const CreatedActions = ({ milestone }: CreatedActionsProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const authorities = AuthConfig.getUserInfo()?.authorities;
  const [copied, setCopied] = useState(false);

  const handleEdit = () => {
    navigate(
      ROUTES.CREATE_COMPLEX_CONTRACT?.replace(
        ":complexId?",
        milestone?.parentId || ""
      ).replace(":milestoneId?", milestone.id || ""),
      { replace: true }
    );
  };

  const handleCopy = useCallback(async () => {
    try {
      await navigator?.clipboard?.writeText(buildContractShareLink(milestone));

      setCopied(true);

      setTimeout(() => setCopied(false), 3000);
    } catch (error) {
      console.error(error);
    }
  }, [milestone]);

  return (
    <>
      {(authorities?.includes("CLIENT_ADMIN_UPDATE_CONTRACT") ||
        authorities?.includes("CLIENT_ADMIN") ||
        authorities?.includes("ORGANIZATION_OWNER")) && (
        <OutlinedButton
          style={{
            width: "129px",
            height: "40px",
            borderRadius: "8px",
            borderColor: "#e2e5ee",
            textAlign: "center",
            whiteSpace: "nowrap",
            fontSize: "16px",
            lineHeight: "24px",
            fontWeight: 500,
            color: "black",
          }}
          onClick={handleEdit}>
          <img
            src="/assets/images/svg/edit.svg"
            alt="edit"
            style={{
              width: "18px",
              height: "18px",
              marginLeft: "8px",
            }}
          />
          {t("lbl_edit")}
        </OutlinedButton>
      )}
      <PrimaryButton
        onClick={handleCopy}
        style={{
          width: "171px",
          height: "40px",
          borderRadius: "8px",
          textAlign: "center",
          whiteSpace: "nowrap",
          fontSize: "14px",
          lineHeight: "100%",
          fontWeight: 500,
          backgroundColor: copied ? "#3ECC85" : "#0d44ad",
        }}>
        {copied ? t("lbl_copied") : t("lbl_share")}
      </PrimaryButton>
    </>
  );
};

export default CreatedActions;
